// Oposición en la que está estudiando el usuario (la última a la que ha entrado).
//
// Las páginas de artículo no llevan la oposición en la ruta, pero siempre se
// llega a ellas desde una oposición (temario, leyes, grafo...), y las
// estadísticas de examen van por oposición: las de Auxilio son de Auxilio
// aunque la ley también se pregunte en Tramitación. Se guarda en localStorage
// para que sobreviva a recargas y a abrir el artículo en otra pestaña.
const LAST_OPPOSITION_KEY = 'almaley_last_opposition';

export const rememberOpposition = (name) => {
  try {
    if (name) localStorage.setItem(LAST_OPPOSITION_KEY, name);
  } catch (_) {
    // localStorage no disponible (modo privado, cuota...): no es crítico
  }
};

export const getLastOpposition = () => {
  try {
    return localStorage.getItem(LAST_OPPOSITION_KEY) || null;
  } catch (_) {
    return null;
  }
};
